import Footer from '../components/Footer.tsx'
import Navbar from '../components/Navbar.tsx'
import "../App.css";
import React, { useRef, useEffect } from 'react';

const Home: React.FC = () => {

  const pageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // @ts-ignore
    pageRef.current.scrollIntoView();
    document.title = `DAGrades`;
  }, []);

  return (
    <div ref={pageRef} className="min-h-screen flex flex-col z-10 relative justify-center items-center bg-dark">
      <Navbar showHome/>
      <div className='flex flex-col justify-start items-center gap-10 mt-10'>
        <h1 className='text-5xl md:text-7xl text-zinc-200 font-bold'><span className='text-primary'>DA</span>Grades</h1>
        <p className='text-zinc-200 text-center font-bold'><span className='glowing-head'>Explore </span><span className='glowing-head-primary'>De Anza </span><span className='glowing-head'>Grade Distributions </span></p>
      </div>
      <div className='flex flex-col justify-start items-center gap-20 relative min-h-[50vh] w-full'>
        <div className="h-full flex justify-center items-center mt-10 mb-0 lg:mb-10">
            <a href="/courses" className='main-button-n'>
              <div className="main-button-inner">
                <div className='main-button-text'>
                Start Browsing
                </div>
              </div>
            </a>
          </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;